import pure from "./higher-order/pure";
import React from "react";

export default pure(class Accordion extends React.Component {
  constructor(props) {
    super(props);
    var { children, onlyOne } = props;
    var expanded = onlyOne ? [] : React.Children.map(children, () => true);
    this.state = { expanded };
  }

  toggle(i) {
    var { onlyOne } = this.props;
    var { expanded } = this.state;

    var copy;
    if (onlyOne) {
      copy = [];
      if (!expanded[i]) {
        copy[i] = true;
      }
    } else {
      copy = expanded.slice(0);
      copy[i] = !copy[i];
    }
    this.setState({ expanded: copy }); // eslint-disable-line react/no-set-state
  }

  render() {
    var { children } = this.props;
    var { expanded } = this.state;

    var kids = React.Children.map(children, (child, i) => {
      if (!child) {
        return child;
      }
      return React.cloneElement(child, {
        expanded: expanded[i],
        onClick: () => this.toggle(i)
      });
    });
    return (
      <div className="accordion">
        {kids}
      </div>
    );
  }
});
